<template>
    <div class="columns is-multiline">
        <b-loading :is-full-page="true" :active.sync="loading" :can-cancel="true"></b-loading>
        <div class="column is-full">
            <b-field label="Visible">
                <b-switch
                v-model="entry.visible"
                ></b-switch>
            </b-field>
        </div>
        <div class="column is-full">
            <b-field label="Titulo">
                <b-input
                v-model="entry.title">
                </b-input>
            </b-field>
        </div>
        <div class="column is-full">
            <b-field label="Descripcion breve">
                <b-input
                maxlength="200"
                type="textarea"
                v-model="entry.description">
                </b-input>
            </b-field>
        </div>
        <div class="column is-full">
            <b-field label="Seccion">
                <b-select
                v-model="entry.section"
                >
                    <option value="">--------</option>
                    <option v-for="sec in sections" :key="sec.id" :value="sec.id">{{sec.title}}</option>
                </b-select>
            </b-field>
        </div>
        <div class="column is-full">
            
            <b-field label="Portada">
                <b-upload 
                    v-model="dropImage"
                    drag-drop
                    style="width:100%; display: block"
                    @input="why"
                    >
                    <section class="section" >
                        <div class=" has-text-centered">
                            <p>
                                <b-icon
                                    icon="upload"
                                    size="is-large">
                                </b-icon>
                            </p>
                            <p>Arrastra tus fotos hasta aqui, o haz click.</p>
                        </div>
                    </section>
                </b-upload>
            </b-field>
            <div v-if="entry.thumbnail" class="insider">
                <img :src="entry.thumbnail">
                <div class="overlay">
                    <b-button 
                    type="is-danger is-small" 
                    rounded
                    @click="clearThumbnail">
                        <b-icon 
                        class="p-0" 
                        icon="times">
                        </b-icon>
                    </b-button>
                </div>
            </div>
        </div>
        <div class="column is-full">
            <b-field>
                <quillEditor
                class="editor__content"
                ref="myTextEditor"
                :value="entry.content"
                :options="editorOption"
                @change="onEditorChange"/>
            </b-field>
        </div>

        <div class="column is-full">
            <TagProducts
            v-if='!isEdit'
            @updateCreationTags="tagsForCreation"
            :productSearch="productSearch"/>

            <EditTagProducts
            v-else
            :productSearch="productSearch"
            :tagCreate="tagCreate"
            :tagRemove="tagRemove"
            :taggedProdListUrl="taggedProdListUrl"
            :entry="entry"
            />
        </div>

        <div class="column is-full">
            <b-button
            rounded
            type="is-primary"
            @click="patchOrCreateEntry">
                <b-icon icon="save" size="is-small" class="m-r-5"></b-icon>
                Guardar
            </b-button>
        </div>
    </div>
</template>

<script>
import { getHandler, patchHandler, postHandler, debounce } from '../../../services/http';
import { quillEditor } from 'vue-quill-editor'
import Quill from 'quill'
import dedent from 'dedent'

import TagProducts from "./components/TagProducts.vue"
import EditTagProducts from "./components/EditTagProducts.vue"

var Font = Quill.import('formats/font');
Font.whitelist = ['montserrat', 'roboto'];
Quill.register(Font, true);
var Size = Quill.import('attributors/style/size');
Size.whitelist = ['10px', '14px', '16px', '18px', '20px'];
Quill.register(Size, true);

export default {
    components:{
        quillEditor,
        TagProducts,
        EditTagProducts
    },
    props:{
        sectionListCreate:{
            type:String,
            default:""
        },
        entryListCreate:{
            type:String,
            default:""
        },
        entryEdit:{
            type:String,
            default:""
        },
        edit:{
            type:String,
            default:""
        },
        productSearch:{
            type:String,
            default:""
        },
        taggedProdListUrl:{
            type:String,
            default:""
        },
        tagCreate:{
            type:String,
            default:""
        },
        tagRemove:{
            type:String,
            default:""
        },
        blogListView:{
            type:String,
            default:""
        }

    },
    data(){
        return{
            loading:false,
            entry:{},
            dropImage:{},
            sections:[],
            editorOption: {
                modules: {
                    toolbar: [
                    ['bold', 'italic', 'underline', 'strike'],
                    ['blockquote', 'code-block'],
                    [{ 'header': 1 }, { 'header': 2 }],
                    [{ 'list': 'ordered' }, { 'list': 'bullet' }],
                    [{ 'script': 'sub' }, { 'script': 'super' }],
                    [{ 'indent': '-1' }, { 'indent': '+1' }],
                    [{ 'direction': 'rtl' }],
                    [{ 'size': ['10px', '14px', '16px', '18px', '20px'] }],
                    [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
                    [{ 'font': ['roboto', 'montserrat'] }],
                    [{ 'color': [] }, { 'background': [] }],
                    [{ 'align': [] }],
                    ['clean'],
                    ['link', 'video']
                    ],
                }
            },
            tags:[],
        }
    },
    computed:{
        isEdit(){
            return this.edit == 'True'
        }
    },
    methods:{
        async fetchEntry(){
            if (this.isEdit){
                this.loading = true
                this.entry = await getHandler(this.entryEdit, {error:false, success:false})
                this.loading = false
            } else{
                this.entry = {}
                return true
            }
        },
        async fetchTags(){
            if (this.isEdit){
                this.loading = true
                this.tags = await getHandler(this.taggedProdListUrl, {error:false, success:false})
                this.loading = false
            } else{
                this.tags = []
                return true
            }
        },
        async fetchSections(){
            this.loading = true
            this.sections = await getHandler(this.sectionListCreate, {error:false, success:false})
            this.loading = false
        },
        async patchOrCreateEntry(){
            var error = {
                resource:'notify'
            }
            var success = {
                resource:'notify'
            }
            this.loading = true
            if (this.isEdit){
                var resp = await patchHandler(this.entryEdit, this.entry, {error, success})
            }
            else{
                var resp = await postHandler(this.entryListCreate, {entry:this.entry, tags:this.tags}, {error, success})
            }
            this.loading = false
            window.location.href = this.blogListView
        },
        onEditorChange: debounce(function(value) {
            this.entry.content = value.html
        }, 266),

        why(){
            let reader = new FileReader();
            reader.readAsDataURL(this.dropImage);
            reader.onloadend = (event) => {
                this.entry.thumbnail = reader.result
            }
        },
        clearThumbnail(){
            this.entry.thumbnail = null
        },
        tagsForCreation(updatedTags){
            this.tags = []
            updatedTags.forEach((element)=>{
                this.tags.push(element.id)
            })
        }
    },
    created(){
        this.fetchEntry()
        this.fetchSections()
    }
}
</script>

<style lang="scss" scoped>


.insider{
    width: 100%;
    display: block;
    position: relative;
}

.overlay{
    opacity: 0;
    transition: all .5s;
    position: absolute;
    z-index: 15000;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    height: 100%;
    width: 100%;
    border-radius: 5px;
    background: rgba(51, 51, 51, 0.296);

    button{
        position:absolute;
        right:5px;
        top:5px;
    }
}
.insider:hover .overlay{
    opacity: 1;
}
.insider:focus .overlay{
    opacity: 1;
}


@import url('https://fonts.googleapis.com/css2?family=Montserrat:wght@300&family=Roboto+Mono:wght@300&family=Roboto:wght@300&display=swap');
.ql-font-roboto{
  font-family: 'Roboto', sans-serif;
}
.ql-font-robotomono{
  font-family: 'Montserrat', sans-serif;
}
.ql-font-montserrat{
  font-family: 'Roboto Mono', monospace;
}
</style>